








































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import {ActionsEnum} from "@/entity/ActionsEnum";
import ImageShow from "@/components/ImageShow.vue";
interface utm {
    id:number;
    session_id:number;
    utm_source: string;
    utm_medium: string;
    utm_campaign: string;
    utm_content: string;
    is_submit: number;
    created_at: string;
    updated_at: string;

}
@Component({
    components: {
        DeleteButton,EForm,Number,TextField,Id,EnabledSwitch,ImageShow
    }
})
export default class GoogleUtm extends  Vue{
    items : utm[] = [];
    dialog = false;
    title:string = "";
    search: string = "";
    baseAction:string = ActionsEnum.GoogleUtm;
    action:string = this.baseAction;
    headers = [
        {
            text: "Id",
            align: "start",
            sortable: true,
            value: "id"
        },
        {text: "Oturum", value: "session_id"},
        {text: "Source", value: "utm_source"},
        {text: "Medium", value: "utm_medium"},
        {text: "Campaign", value: "utm_campaign"},
        {text: "Content", value: "utm_content"},
        {text: "Form gönderildi mi ?", value: "is_submit"},
        {text: "Oluşturulma tarihi", value: "created_at"},
        {text: "Düzenlenme tarihi", value: "updated_at"},
        {text: "İşlemler", value: "actions"}
    ];
    async get(){
        this.dialog = false;
        let response = await this.$http.get(this.baseAction);
        this.items = response.data;
    }
    created(){
        this.get();
    }
};
